import { render, staticRenderFns } from "./partner_entities_vime_index.vue?vue&type=template&id=2d2df247"
import script from "./partner_entities_vime_index.vue?vue&type=script&lang=js"
export * from "./partner_entities_vime_index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports